import "./App.css";
import { Route, Switch } from "react-router-dom";
import NotFound from "./pages/page-notFound";
import VerifyEmailPrivate from "./pages/verification/private";
import VerifyEmailBusiness from "./pages/verification/business";
import ResetPasswordPrivate from "./pages/reset-password/private";
import ResetPasswordBusiness from "./pages/reset-password/business";
import ResetSuccessful from "./pages/components/reset-password/reset-successfully";
import AboutUs from "./pages/mobile/about-us";
import FrequentlyAskedQuestions from "./pages/mobile/faq";
import FrequentlyAskedQuestionsSQ from "./pages/mobile/faq-sq";
import FrequentlyAskedQuestionsSR from "./pages/mobile/faq-sr";
import termsandcontitionsbiz from "./pages/mobile/terms-and-conditions-biz";
import termsandcontitionspriv from "./pages/mobile/terms-and-conditions-priv";
import depositInstructions from "./pages/mobile/deposit";
import depositInstructionsEN from "./pages/mobile/deposit-en";
import depositInstructionsSR from "./pages/mobile/deposit-sr";
import { useEffect } from "react";
import useQuery from "./shared/functions/functions";
import i18n from "./i18n";

function App() {
  const query = useQuery();

  useEffect(() => {
    const urlLang = query.get("lang");

    const lang = urlLang || "en";

    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [query]);

  return (
    <div className="App">
      <Switch>
        <Route
          path="/private/verify-email"
          exact
          component={VerifyEmailPrivate}
        />
        <Route
          path="/business/verify-email"
          exact
          component={VerifyEmailBusiness}
        />
        <Route
          path="/private/reset-password"
          exact
          component={ResetPasswordPrivate}
        />
        <Route
          path="/business/reset-password"
          exact
          component={ResetPasswordBusiness}
        />
        <Route path="/about-us" exact component={AboutUs} />
        <Route path="/faq" exact component={FrequentlyAskedQuestions} />
        <Route path="/faq-sq" exact component={FrequentlyAskedQuestionsSQ} />
        <Route path="/faq-sr" exact component={FrequentlyAskedQuestionsSR} />

        <Route path="/terms-biz" exact component={termsandcontitionsbiz} />
        <Route path="/deposit" exact component={depositInstructions} />
        <Route path="/deposit-en" exact component={depositInstructionsEN} />
        <Route path="/deposit-sr" exact component={depositInstructionsSR} />
        <Route path="/terms-priv" exact component={termsandcontitionspriv} />
        <Route path="/reset-successful" exact component={ResetSuccessful} />
        <Route path="/page-not-found" exact component={NotFound} />
      </Switch>
    </div>
  );
}

export default App;
